<template>
  <div class="p-6 flex flex-col gap-8 description-color">
    <div
      class="border-2 p-4 px-6 boxComponent ripple"
      @click="selectOption(option)"
      :style="{
        borderColor: activeOption.id == option.id ? option.activeColor : 'gray',
      }"
      v-for="(option, i) in options[service.serviceId] || []"
      :key="i"
    >
      <div class="flex items-center gap-2">
        <div class="w-5 h-5">
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            class="w-full h-full"
            :fill="activeOption.id == option.id ? option.activeColor : 'gray'"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet"
          >
            <g
              transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
              stroke="none"
            >
              <path
                d="M2330 5110 c-494 -48 -950 -230 -1350 -538 -195 -150 -448 -432 -594 -662 -63 -99 -186 -351 -230 -471 -49 -134 -102 -340 -128 -499 -31 -195 -31 -565 0 -760 45 -276 116 -498 237 -745 132 -269 269 -460 489 -681 221 -220 412 -357 681 -489 247 -121 469 -192 745 -237 195 -31 565 -31 760 0 276 45 498 116 745 237 269 132 460 269 681 489 220 221 357 412 489 681 88 179 132 296 180 476 63 240 78 371 78 649 0 278 -15 409 -78 649 -48 180 -92 297 -180 476 -132 269 -269 460 -489 681 -221 220 -412 357 -681 489 -246 121 -474 193 -740 235 -147 23 -475 34 -615 20z m1569 -1452 c50 -16 127 -91 148 -146 24 -64 22 -147 -6 -205 -32 -65 -1678 -1699 -1752 -1740 -72 -38 -156 -38 -228 1 -42 22 -800 701 -929 832 -51 51 -76 113 -75 185 2 151 113 253 263 243 36 -3 80 -12 97 -22 27 -13 532 -468 696 -625 l47 -46 748 747 c411 410 761 753 779 762 69 35 131 39 212 14z"
              />
            </g>
          </svg>
        </div>
        <div
          class="font-medium"
          :style="{
            color:
              activeOption.id == option.id ? option.activeColor : 'inherit',
          }"
        >
          {{
            $t(
              `transactions.launchOptions.${service.serviceId}.${
                option.id
              }.title`,
            )
          }}
        </div>
      </div>
      <div class="py-2"></div>
      <div
        class="text-xl font-medium"
        :class="{ 'title-color': activeOption.id == option.id }"
      >
        {{
          $t(
            `transactions.launchOptions.${service.serviceId}.${
              option.id
            }.description`,
          )
        }}
      </div>
      <div class="font-medium">
        {{
          $t(
            `transactions.launchOptions.${service.serviceId}.${
              option.id
            }.smallDescription`,
          )
        }}
      </div>
      <div class="py-2"></div>
    </div>
    <div class="buttonComponent mt-4" @click="confirmSelectedOption">
      {{ $t('transactions.launchOptions.continue') }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TransactionOptionSelector',
  components: {},
  props: {
    service: { type: Object, default: {} },
    defaultOptionId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      eventsIds: [],
      options: {
        '1xbet': [
          {
            id: 'fund',
            activeColor: '#00ABFD',
          },
          {
            id: 'withdraw',
            activeColor: '#00ABFD',
          },
        ],
        '1win': [
          {
            id: 'fund',
            activeColor: '#080E1E',
          },
          {
            id: 'withdraw',
            activeColor: '#080E1E',
          },
        ],
        betwinner: [
          {
            id: 'fund',
            activeColor: '#007F5D',
          },
          {
            id: 'withdraw',
            activeColor: '#007F5D',
          },
        ],
        melbet: [
          {
            id: 'fund',
            activeColor: '#070707',
          },
          {
            id: 'withdraw',
            activeColor: '#070707',
          },
        ],
        eightStarz: [
          {
            id: 'fund',
            activeColor: '#771512',
          },
          {
            id: 'withdraw',
            activeColor: '#771512',
          },
        ],
        pm: [
          {
            id: 'buy',
            activeColor: '#ED3122',
          },
          {
            id: 'sell',
            activeColor: '#ED3122',
          },
        ],
        usdt: [
          {
            id: 'buy',
            activeColor: '#00AC7F',
          },
          {
            id: 'sell',
            activeColor: '#00AC7F',
          },
        ],
        wallet: [
          {
            id: 'fund',
            activeColor: '#37b6e9',
          },
          {
            id: 'withdraw',
            activeColor: '#37b6e9',
          },
        ],
        giftCard: [
          {
            id: 'buy',
            activeColor: '#e76f51',
          },
          {
            id: 'sell',
            activeColor: '#e76f51',
          },
        ],
      },
      activeOption: {},
    }
  },
  mounted() {
    if (!this.options[this.service.serviceId]) {
      console.warn('option not available for servcie ' + this.service.serviceId)
      this.$emit('noOptionFound')
      return
    }
    this.selectDefaultOption()
    this.trySelectDefaultOption()
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    trySelectDefaultOption() {
      console.log(this.defaultOptionId, "mmom")
      if (!this.defaultOptionId) return
      const matchingOption = this.options[this.service.serviceId].find(
        option => option.id == this.defaultOptionId,
      )
      if (!matchingOption) return
      this.selectOption(matchingOption)
      this.confirmSelectedOption()
    },
    selectDefaultOption() {
      this.activeOption = this.options[this.service.serviceId][0]
    },
    selectOption(option) {
      this.activeOption = option
    },
    confirmSelectedOption() {
      if (!this.activeOption.id) {
        this.$Events.dispatchEvent('toast_notification', {
          body: this.$t('transactions.launchOptions.selectOption'),
        })
        return
      }
      // if (
      //   this.activeOption.id === "sell" &&
      //   this.service.serviceId === "usdt"
      // ) {
      //   this.$Events.dispatchEvent("toast_notification", {
      //     body: this.$t("transactions.launchOptions.soonAvailable"),
      //   });
      //   return;
      // }
      this.$emit('optionSelected', this.activeOption)
    },
  },
})
</script>
